"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconRightArrow = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M61.74 37.28L64 35 41.49 12.47a3.85 3.85 0 0 0-2.76-1.15A3.94 3.94 0 0 0 36 12.48 3.92 3.92 0 0 0 36 18l13.34 13.42H8.07a4 4 0 0 0-4.2 3.76 4 4 0 0 0 4.2 3.76H49L36 52a3.9 3.9 0 0 0 5.52 5.51L61.06 38a4.37 4.37 0 0 0 .68-.72z"
  })),
  height: undefined,
  width: undefined
});
IconRightArrow.displayName = 'IconRightArrow';
var _default = IconRightArrow;
exports["default"] = _default;